import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import { connect } from 'react-redux'

import AppBar from '@material-ui/core/AppBar'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'

//components
import AdminWrapper from '../../../containers/AdminWrapper';
import ContentWrapper from '../../../containers/ContentWrapper';
import DetailsTab from '../ViewShoot/DetailsTab';
import VideoShotsTab from '../ViewShoot/VideoShotsTab';
import PhotoShotsTab from '../ViewShoot/PhotoShotsTab';

class CheckShootTabs extends Component {

  componentDidMount(){
    console.log("Mounted!")
  }

  //if we use the queryStrings check if the querystrings is completed
  //if not go to status 404 page not found page
  //if we use this format /shoots/view/:clientname/:date
  //there are lots of possibilities. we can have a page that has the list of the client's
  //profile. but I don't think that we will have multiple shoots for the clients
  //if there is not date then we can redirect them to the status 404 not found page.

  handleChange = (e,value) => {
    const {client, date} = this.props.match.params
    if(value === "/shoots/check/:client/:date")
      this.props.history.push(`/shoots/check/${client}/${date}`)
    if(value === "/shoots/check/:client/:date/photo")
      this.props.history.push(`/shoots/check/${client}/${date}/photo`)
      if(value === "/shoots/check/:client/:date/video")
      this.props.history.push(`/shoots/check/${client}/${date}/video`)
  }

  render() {
    return (
      <AdminWrapper {...this.props} >
        <ContentWrapper hasHeader title="View Shoot">
          <AppBar elevation={0} position="static">
            <Tabs value={this.props.match.path} onChange={this.handleChange}>
              <Tab label="Details" value="/shoots/check/:client/:date"/>
              <Tab label="Photo Shots" value="/shoots/check/:client/:date/photo" />
              <Tab label="Video Shots" value="/shoots/check/:client/:date/video" />
              {/* conditional tab, this is the tab to manage where the agencies
              upload the raw files. */}
              {/* <Tab label="Video Shots" value="/category" /> */}
            </Tabs>
          </AppBar>
          
          <Route exact path="/shoots/check/:name/:date" render={(props)=> <DetailsTab check {...props} />} />
          <Route exact path="/shoots/check/:name/:date/photo" render={(props)=> <PhotoShotsTab check {...props} />} />
          <Route exact path="/shoots/check/:name/:date/video" render={(props)=> <VideoShotsTab check {...props} />} />
          {/* <Route exact path="/shoots/check/files" component={ShootsTab} /> */}
        </ContentWrapper>
      </AdminWrapper>
    )
  }
}

const mapStateToProps = state => {
  return{
    router:state.router.location
  }
}


export default connect(mapStateToProps)(CheckShootTabs)